import { Box, CircularProgress, Container, Typography } from '@mui/material';
import { TrendsScienceCard } from './TrendsScienceCard';
import { Helmet } from 'react-helmet';
import { useTrendsData } from './useTrendsData';

export const TrendsAndScience = () => {
  const trendsData = useTrendsData();
  return (
    <>
      <Helmet>
        <title>Trends and science</title>
      </Helmet>
      <Box>
        <Container sx={{ py: 8 }}>
          <Typography variant="h2" sx={{ color: 'white', mb: 2 }}>
            Trends & science
          </Typography>

          {trendsData === undefined ? (
            <Box
              sx={{
                height: '70vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <CircularProgress color="primary" />
            </Box>
          ) : (
            <Box
              sx={{
                display: 'grid',
                gap: 2,

                gridTemplateColumns: {
                  xs: '1fr',
                  lg: '1fr 1fr'
                },

                gridAutoRows: '1fr'
              }}
            >
              {trendsData.map(card => (
                <TrendsScienceCard card={card} key={card.title} />
              ))}
            </Box>
          )}
        </Container>
      </Box>
    </>
  );
};
